
<form class="card" [formGroup]="changeRequestForm" (ngSubmit)="submitForm()">
    <div class="table-container">
        <table class="readonly-fields">
            <tr>
                <td><strong>Vendor Code: {{ changeRequestForm.get('vendor_code')?.value }}</strong></td>
                <td><strong>Business Name: {{ changeRequestForm.get('business_name')?.value }}</strong></td>
                <td><strong>Type: {{ changeRequestForm.get('vendor_classification')?.value }}</strong></td>
                <td><strong>Address Type: {{ changeRequestForm.get('address_type')?.value }}</strong></td>

            </tr>
        </table>
    </div>
    <div style="margin-top:30px"></div>
    <p-accordion>
        <p-accordionTab header="Other Address">
            <ng-template pTemplate="content">
                <div formGroupName="other_address" class="grid-container" id="other_address" style="margin-bottom: 35px;">
                    <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                        <label for="address_title"><strong>Address Title</strong><span
                                class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
                        <input id="address_title" type="text" pInputText  formControlName="address_title"  />
                    </div>
                    <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                        <label><strong>Address Type</strong><span class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
                        <p-dropdown [options]="options1" formControlName="address_type" placeholder="Select an Option"></p-dropdown>
                    </div>
                    <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                        <label for="address_line_1"><strong>Address Line 1</strong><span
                                class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
                        <input id="address_line_1" formControlName="address_line_1" type="text" pInputText  />
                    </div>
                    <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                        <label for="address_line_2"><strong>Address Line 2</strong>&nbsp;&nbsp;&nbsp;</label>
                        <input id="address_line_2" formControlName="address_line_2" type="text" pInputText  />
                    </div>
                    <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                        <label for="city"><strong>City/Town</strong>&nbsp;&nbsp;&nbsp;</label>
                        <input id="city" type="text" formControlName="city" pInputText  />
                    </div>
                    <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                        <label for="country"><strong>Country</strong>&nbsp;&nbsp;&nbsp;</label>
                        <input id="country" type="text" formControlName="country" pInputText  />
                    </div>
                    <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                        <label for="state"><strong>State/Province</strong>&nbsp;&nbsp;&nbsp;</label>
                        <p-dropdown formControlName="state" [options]="state" optionLabel="label" optionValue="value"
                            placeholder="Select a State" />
                        <!-- <input id="state" type="text"  formControlName="state"pInputText  /> -->
                    </div>
                    <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                        <label for="postal_code"><strong>Postal Code</strong>&nbsp;&nbsp;&nbsp;</label>
                        <input id="postal_code" (keydown)="validateNumber($event)" formControlName="postal_code" type="text" pInputText  />
                    </div>
                    <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                        <label for="email_address"><strong>Email Address</strong>&nbsp;&nbsp;&nbsp;</label>
                        <input id="email_address" formControlName="email_address" type="email" pInputText  />
                    </div>
                    <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                        <label for="phone_no"><strong>Phone No</strong>&nbsp;&nbsp;&nbsp;</label>
                        <input id="phone_no" (keydown)="validateNumber($event)" formControlName="phone_no" type="text" pInputText  />
                    </div>
                    <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                        <label for="fax"><strong>Fax</strong>&nbsp;&nbsp;&nbsp;</label>
                        <input id="fax" type="text" formControlName="fax" pInputText  />
                    </div>                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab header="Contact Details">
            <ng-template pTemplate="content">
                <div formGroupName="other_address">
                    <div formGroupName="contact_person" class="grid-container" style="margin-bottom: 35px;">
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="name1"><strong>Name</strong><span class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
                            <input id="name1" type="text" formControlName="name1" pInputText  />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="phone_no"><strong>Phone No</strong>&nbsp;&nbsp;&nbsp;</label>
                            <input id="phone_no" (keydown)="validateNumber($event)" type="text" formControlName="phone_no" pInputText  />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="mobile_no"><strong>Mobile No</strong><span
                                    class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
                            <input id="mobile_no" (keydown)="validateNumber($event)" type="text" formControlName="mobile_no" pInputText  />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="e_mail_id"><strong>E Mail ID</strong><span
                                    class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
                            <input id="e_mail_id" type="email" formControlName="e_mail_id" pInputText  />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="website_url"><strong>Website/ URL</strong>&nbsp;&nbsp;&nbsp;</label>
                            <input id="website_url" formControlName="website_url" type="text" pInputText  />
                        </div>                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab header="Bank Details">
            <ng-template pTemplate="content">
                <div formGroupName="other_address">
                    <div formGroupName="bank_detail" class="grid-container" style="margin-bottom: 35px;">
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="account_holder__registered_name"><strong>Account Holder/Name</strong><span
                                    class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
                            <input id="account_holder__registered_name" formControlName="account_holder__registered_name" type="text" pInputText  />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="account_no"><strong>Account No</strong><span
                                    class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
                            <input id="account_no" (keydown)="validateNumber($event)" type="text" formControlName="account_no" pInputText  />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="bank_name"><strong>Bank Name</strong>&nbsp;&nbsp;&nbsp;</label>
                            <input id="bank_name" type="text" formControlName="bank_name" pInputText  />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="bank_address"><strong>Bank Address</strong>&nbsp;&nbsp;&nbsp;</label>
                            <input id="bank_address" type="text" formControlName="bank_address" pInputText  />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="ifsc_code"><strong>IFSC Code</strong><span
                                    class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
                            <input id="ifsc_code" type="text" formControlName="ifsc_code" pInputText  />
                        </div>                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab header="Tax Details">
            <ng-template pTemplate="content">
                <div formGroupName="other_address">
                    <div formGroupName="tax_details" class="grid-container" style="margin-bottom: 35px;">
                        <!-- <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="gstn">GSTN<span class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
                            <input id="gstn" type="text"  formControlName="gstn" pInputText  />
                        </div> -->
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;" *ngIf="isCountryIndia(changeRequestForm.get('other_address')?.get('country')?.value)">
                            <label for="gstn">GSTN <span class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
                            <input id="gstn" type="text" pInputText formControlName="gstn" />
                            <div *ngIf="changeRequestForm.get('other_address')?.get('tax_details')?.get('gstn')?.invalid && changeRequestForm.get('other_address')?.get('tax_details')?.get('gstn')?.touched">
                              <small class="p-error">GSTN is required.</small>
                            </div>
                        </div>

                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="vat_registration_number"><strong>VAT Registration Number</strong>&nbsp;&nbsp;&nbsp;</label>
                            <input id="vat_registration_number"  formControlName="vat_registration_number" type="text" pInputText  />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label for="service_tax_registration_number"><strong>Service Tax Registration Number</strong></label>
                            <input id="service_tax_registration_number"  formControlName="service_tax_registration_number" type="text" pInputText  />
                        </div>                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
    </p-accordion>
    <div class="button-group" style="margin-top: 20px;display: flex; justify-content: center;">
        <button pButton type="button"  label="Submit" [disabled]="!changeRequestForm.valid" (click)="submitForm()"></button>
    </div>
</form>
<p-toast></p-toast>
